/* Saffron Realm — scroll reveal for home page sections.
   Additive only: if anything here fails, content stays visible because the
   .sr-in class is applied by this script rather than baked into the markup. */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-index')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var run = function () {
    var targets = [];

    // Skip the first section so the hero is never hidden on load.
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
    sections.slice(1).forEach(function (section) {
      var inner = section.querySelector(
        '.section-header, .grid-product, .promo-grid__item, .testimonial-item, .article__grid-item, .text-columns__item, .background-media-text__inner, .feature-row__text, .feature-row__image'
      );
      if (inner) {
        Array.prototype.slice
          .call(
            section.querySelectorAll(
              '.section-header, .grid-product, .promo-grid__item, .testimonial-item, .article__grid-item, .text-columns__item, .background-media-text__inner, .feature-row__text, .feature-row__image'
            )
          )
          .forEach(function (el) { targets.push(el); });
      }
    });

    if (!targets.length) return;

    targets.forEach(function (el, i) {
      el.classList.add('sr-in');
      el.style.transitionDelay = (i % 3) * 90 + 'ms';
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sr-shown');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );

    targets.forEach(function (el) { io.observe(el); });

    // Safety net: if anything is still hidden after 3s, show it.
    window.setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('sr-shown'); });
    }, 3000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
